// Unpublished Work © 2025-2026 Deere & Company.

import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'Utils/prop-type-utils';
import {Box, Card, Grid} from '@deere/isg.component-library';
import WorkboardOperators from './workboard-operators';
import WorkboardJobs from './workboard-jobs';
import WorkboardCutsAndDirections from './workboard-cuts-and-directions';
import WorkboardDetails from './workboard-details';
import LoadingWrapper from 'Src/ui-core/components/common/loading-wrapper';
import {JOB} from 'OnLabor/workboard/constants/workboard-creation-flows';

const GRID_PROPS = {
    sx: {
        flex: '1'
    },
    size: {
        xs: 12,
        md: 3
    }
};

function SetupWorkboard(props) {
    const {
        groupBy,
        isEditing,
        isLoading,
        translations,
        type
    } = props;

    const setupSteps = [
        {
            Component: WorkboardDetails,
            props: {
                isEdit: isEditing,
                type
            }
        },
        {
            Component: WorkboardOperators,
            props: {}
        },
        {
            Component: WorkboardJobs,
            props: {}
        },
        {
            Component: WorkboardCutsAndDirections,
            props: {}
        }
    ];

    if (groupBy === JOB) {
        [setupSteps[1], setupSteps[2]] = [setupSteps[2], setupSteps[1]];
    }

    return (
        <LoadingWrapper
            className='workboard-setup-loading-icon'
            loading={isLoading}
            size='50px'
        >
            <Box
                paddingBottom='64px'
                width='100%'
            >
                <Grid
                    container
                    direction={{
                        xs: 'column',
                        md: 'row'
                    }}
                    justifyContent={'space-between'}
                    padding='16px'
                    spacing={4}
                >
                    {setupSteps.map(({
                        Component, props
                    }, i) => (
                        <Grid
                            {...GRID_PROPS}
                        >
                            <Card
                                sx={{
                                    minHeight: '120px'
                                }}
                            >
                                <Component
                                    key={i}
                                    {...props}
                                    translations={translations}
                                />
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </LoadingWrapper>
    );
}

SetupWorkboard.propTypes = {
    groupBy: PropTypes.string,
    isEditing: PropTypes.bool,
    isLoading: PropTypes.bool,
    translations: PropTypes.translations,
    type: PropTypes.string
};

export function mapStateToProps(state) {
    return {
        isLoading: state.setupWorkboard.loadingSetup,
        isEditing: state.setupWorkboard.isEditing
    };
}

export default connect(mapStateToProps, null)(SetupWorkboard);
